<template>
    <div>
        <!--搜索表单-->
        <div class="search-form">
            <a-space :size="30">
                <ButtonTabs :options="ConstValue.roleList" @change="search" state-key="search.role" v-model="params.role"/>
                <a-space :size="30">
                    <a-input-search @search="search" placeholder="相册名 / 相册码" v-model="params.keyword"/>
                    <BoolSwitch :false-value="0" :true-value="2" @change="search" state-key="search.closed" title="未结束" v-model="params.closed"/>
                </a-space>
            </a-space>
            <a-button @click="onCreate" icon="plus" style="float: right;" type="primary">创建相册</a-button>
        </div>
        <!--相册列表-->
        <a-spin :spinning="loading" size="large" tip="Loading">
            <div :style="{height:listHeight+'px'}" class="album-list" ref="albumList">
                <a-card :key="member.id" :style="{width: colWidth+'px'}"
                        class="album-card" v-for="member in result.data">
                    <div :style="{height: colWidth/2+'px'}" slot="cover">
                        <ResourceImg :id="member.album.cover" resize="m_8,w_480,h_240" v-if="member.album.cover"/>
                        <img alt="" src="../../../assets/cover.jpg" v-else/>
                    </div>
                    <a-card-meta>
                        <div slot="title">{{ member.album.name.substr(0, 18) }}</div>
                        <div slot="description" style="line-height: 28px;">
                            <div>
                                <a-icon type="flag"/> 地点：
                                {{ member.album.address.slice(1, 2).join(" ").substr(0, 18) }}
                            </div>
                            <div>
                                <a-icon type="clock-circle"/> 时间：
                                {{ member.album.period[0] | tsFormat("YYYY/MM/DD") }} ~ {{ member.album.period[1] | tsFormat("YYYY/MM/DD") }}
                            </div>
                            <div>
                                <a-icon type="user"/> 角色：
                                <a-tag :key="role" v-for="role in member['roles']">{{ConstValue.roleName[role]}}</a-tag>
                            </div>
                        </div>
                    </a-card-meta>
                    <template slot="actions">
                        <CardAction :disabled="notManager(member)" @click="onDelete(member)" icon="delete" title="删除相册"/>
                        <CardAction :disabled="notManager(member)" @click="onStatis(member)" icon="line-chart" title="统计数据"/>
                        <CardAction @click="onShare(member)" icon="share-alt" title="分享传播"/>
                        <CardAction :disabled="notManager(member)" @click="onMember(member)" icon="usergroup-add" title="成员管理"/>
                        <CardAction :disabled="notManager(member)" @click="onConfig(member)" icon="setting" title="相册设置"/>
                        <CardAction @click="onPhoto(member)" icon="picture" title="图片管理"/>
                    </template>
                </a-card>
                <!--分页器-->
                <a-pagination
                    :hideOnSinglePage="true" :pageSize="params.page_size"
                    :total="result.total" @change="refresh"
                    class="pagination" v-model="params.page_no"/>
                <a-empty :style="{marginTop: listHeight/3+'px'}" description="暂无相册" v-if="result.data.length===0"/>
            </div>
        </a-spin>
        <!--相册添加/编辑弹窗-->
        <AlbumCreate @saved="refresh" ref="albumCreate"/>
        <!--删除确认-->
        <DeleteConfirm @deleted="refresh" ref="deleteConfirm"/>
        <!--分享传播弹窗-->
        <AlbumShare ref="albumShare"/>
    </div>
</template>

<script>
    import api from "../../../utils/api";
    import func from "../../../utils/func";
    import ConstValue from "./ConstValue";
    import CardAction from "./comps/CardAction";
    import ResourceImg from "../../../comps/ResourceImg";
    import AlbumShare from "./comps/AlbumShare";
    import AlbumCreate from "./comps/AlbumCreate";
    import ButtonTabs from "../../../comps/ButtonTabs";
    import BoolSwitch from "../../../comps/BoolSwitch";
    import enums from "../../../utils/enums";
    import DeleteConfirm from "./comps/DeleteConfirm";
    import DelayLoading from "../../../comps/DelayLoading";

    export default {
        name: "List",
        mixins: [DelayLoading],
        components: {DeleteConfirm, BoolSwitch, ButtonTabs, AlbumCreate, AlbumShare, CardAction, ResourceImg},
        data() {
            return {
                params: {
                    role: 0,
                    keyword: "",
                    closed: 0,
                    page_no: 1,
                    page_size: 60,
                },
                result: {
                    total: 0,
                    data: [],
                },
                ConstValue: ConstValue,
            };
        },
        computed: {
            colWidth() {
                return func.computedColWidth({
                    count: 5, gutter: 16, range: [340, 400],
                    width: this.$store.getters["layout/contentWidth"] - 32
                });
            },
            listHeight() {
                return this.$store.getters["layout/contentHeight"] - 66;
            }
        },
        mounted() {
            this.search();
        },
        methods: {
            search() {
                this.params.page_no = 1;
                this.refresh();
            },
            refresh() {
                this.withLoading(300, () => api.v1.album.search(this.params))
                    .then(res => this.result = res);
            },
            onCreate() {
                this.$refs.albumCreate.open();
            },
            onDelete(member) {
                this.$refs.deleteConfirm.open(member);
            },
            onShare(member) {
                this.$refs.albumShare.open(member.album.id);
            },
            onConfig(member) {
                this.$router.push({name: "Album.Config.Info", params: {id: member.album.id}});
            },
            onMember(member) {
                this.$router.push({name: "Album.Config.Member", params: {id: member.album.id}});
            },
            onStatis(member) {
                this.$router.push({name: "Album.Statis", params: {id: member.album.id}});
            },
            onPhoto(member) {
                this.$router.push({name: "Album.Photo", params: {id: member.album.id}});
            },
            notManager(member) {
                return enums.Role.isManager(member["roles"]) === false;
            },
        }
    }
</script>

<style lang="less" scoped>
    .search-form {
        z-index: 100;
        margin-top: 3px;
        padding: 15px 16px;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 5px 5px #dedede;
    }

    .album-list {
        width: 100%;
        padding: 8px;
        overflow-y: scroll;

        .album-card {
            float: left;
            margin: 8px;

            img {
                width: 100%;
            }
        }

        .pagination {
            width: 100%;
            clear: both;
            padding: 10px 8px;
            text-align: right;
        }
    }
</style>
